import { create } from 'zustand';

type PanelType = 'none' | 'textManipulation' | 'financialAnalysis' | 'opportunityCost' | 'lod' | 'layerList' | 'processSourceDWG' | 'jsonDataExtraction' | 'spaceAssociation' | 'vizQuerySetup' | 'applicationSetup' | 'aiSetup' | 'informationLayersSetup' | 'svgStyling';

export interface ProcessParameter {
  name: string;
  value: string;
}

interface SpaceToolsState {
  activePanel: PanelType;
  menuOpen: boolean;
  selectedLayers: string[];
  setActivePanel: (panel: PanelType) => void;
  togglePanel: (panel: PanelType) => void;
  closePanel: () => void;
  setMenuOpen: (open: boolean) => void;
  toggleMenu: () => void;
  toggleLayerSelection: (layerName: string) => void;
  clearSelectedLayers: () => void;
  lodFolder: string | null;
  setLodFolder: (folderPath: string | null) => void;
  lodSpaceLayer: string | null;
  setLodSpaceLayer: (layer: string | null) => void;
  lodTextLayer: string | null;
  setLodTextLayer: (layer: string | null) => void;
  processSpaceLayer: string | null;
  setProcessSpaceLayer: (layer: string | null) => void;
  processTextLayer: string | null;
  setProcessTextLayer: (layer: string | null) => void;
  processParameters: ProcessParameter[];
  setProcessParameters: (params: ProcessParameter[]) => void;
  jsonParameters: ProcessParameter[];
  setJsonParameters: (params: ProcessParameter[]) => void;
}

export const useSpaceToolsStore = create<SpaceToolsState>((set) => ({
  activePanel: 'none',
  menuOpen: false,
  selectedLayers: [],
  lodFolder: null,
  lodSpaceLayer: null,
  lodTextLayer: null,
  processSpaceLayer: null,
  processTextLayer: null,
  processParameters: [
    { name: "LAST", value: "" },
    { name: "EXTENTS", value: "" }
  ],
  jsonParameters: [{ name: "BLOCKS", value: "" }],

  setLodFolder: (folderPath) => set({ lodFolder: folderPath }),
  setLodSpaceLayer: (layer) => set({ lodSpaceLayer: layer }),
  setLodTextLayer: (layer) => set({ lodTextLayer: layer }),
  setProcessSpaceLayer: (layer) => set({ processSpaceLayer: layer }),
  setProcessTextLayer: (layer) => set({ processTextLayer: layer }),
  setProcessParameters: (params) => set({ processParameters: params }),
  setJsonParameters: (params) => set({ jsonParameters: params }),

  setActivePanel: (panel) => set({ activePanel: panel, menuOpen: false }),

  togglePanel: (panel) => set((state) => ({
    activePanel: state.activePanel === panel ? 'none' : panel,
    menuOpen: false,
  })),

  closePanel: () => set({ activePanel: 'none', menuOpen: true }),

  setMenuOpen: (open) => set({ menuOpen: open }),

  toggleMenu: () => set((state) => ({ menuOpen: !state.menuOpen })),

  toggleLayerSelection: (layerName) => set((state) => {
    const isSelected = state.selectedLayers.includes(layerName);
    return {
      selectedLayers: isSelected
        ? state.selectedLayers.filter((l) => l !== layerName)
        : [...state.selectedLayers, layerName],
    };
  }),

  clearSelectedLayers: () => set({ selectedLayers: [] }),
}));
